import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom"

import BroadcastForm from "../components/BroadcastForm";
import AdminNavbar from "../components/AdminNavbar";
import Modal from "../components/Modal";
import MobileNavbar from "../components/MobileNavbar";
import AdminMobileNavOverlay from "../components/AdminMobileNavOverlay";

const AdminLayout = () => {
  const [isBroadcastEditorModalOpen, setIsBroadcastEditorModalOpen] = useState(false);
  const [isMobileNavOverlayOpen, setIsMobileNavOverlayOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setIsMobileNavOverlayOpen(false);
  }, [location.pathname]);

  const handleBroadcastClicked = () => {
    setIsMobileNavOverlayOpen(false);
    setIsBroadcastEditorModalOpen(true);
  }

  return (
    <div className="flex flex-col min-h-screen">
      <AdminNavbar onBroadcastClicked={e => setIsBroadcastEditorModalOpen(true)} />
      <MobileNavbar onHamburgerClicked={e => setIsMobileNavOverlayOpen(true)} />

      <AdminMobileNavOverlay
        isOpen={isMobileNavOverlayOpen}
        onBroadcastClicked={handleBroadcastClicked}
        onCloseClicked={e => setIsMobileNavOverlayOpen(false)}
      />

      <main className="flex justify-center flex-grow">
        <div className="container px-2 md:px-0 pt-[66px] pb-[20px] md:py-[20px]">
          <Outlet />
        </div>
      </main>

      <Modal isOpen={isBroadcastEditorModalOpen} >
        <BroadcastForm
          onCloseClicked={e => setIsBroadcastEditorModalOpen(false)}
        />
      </Modal>
    </div>
  );
}

export default AdminLayout;
